import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, ValidatorFn } from '@angular/forms';

export function controlValueIsSmallerThanTargetValidator(targetValue: number, errorMessage: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const controlValue = +control.value;
    const error = {} as { [key: string]: any };
    error[errorMessage] = targetValue;
    return controlValue >= targetValue ? error : null;
  };
}

@Directive({
  selector: '[appFieldValueSmallerThan]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: FieldValueSmallerThanDirective, multi: true }],
})
export class FieldValueSmallerThanDirective {
  @Input()
  targetField: HTMLInputElement;

  @Input()
  errorMessage = 'commons.validations.max';

  validate(control: AbstractControl): ValidationErrors | null {
    const targetValue = +this.targetField?.value;
    return control.value && targetValue ? controlValueIsSmallerThanTargetValidator(targetValue, this.errorMessage)(control) : null;
  }
}
